// import Evaluation from './Evaluation';

export default {
  // component: Evaluation,
  component: load(() => import(/* webpackChunkName: "Evaluation360-Evaluation" */ './Evaluation')),
  permissions: ["360EvaluationMenu/EvaluateMenu"],
  name: app.translate('routes.home.evaluation-360.Evaluation'),
  icon: 'account-convert',
  drawer: true,
};
